import { useState } from 'react';
import { Button, Divider, Stack, Typography, Box } from "@mui/material";
import { alertService } from "../../services/alerting/alerting";
import { ServiceContext } from "../../hooks/serviceRegistry/serviceContext";
import { useContext } from "react";
import { useLocalStorage } from '../../hooks/useLocalStorage';



const UCR_SAFETY_STOP_LAMBDA_ARN = 'arn:aws:lambda:eu-west-1:745905534821:function:UnicreditSafetyStop';

export default function Pulsantone() {

    const { getSvc } = useContext(ServiceContext)
    const lambda = getSvc("client_pulsantone");

    const [step, setStep] = useState(0);
    const [lastConfirmation, setLastConfirmation] = useLocalStorage('unicreditSafetyStopLastConfirmation',0);

    const canStop = (new Date().valueOf() - lastConfirmation) >= 15 * 1000;

    // const onRpaStopConfirmed = async () => {

    //     try {
    //         alert("BOOOOOM!");
    //         alertService.info("Stop RPA riuscito")
    //     } catch (e) {
    //         alertService.error("Stop RPA fallito")
    //     }
    //     setLastConfirmation((new Date()).valueOf());
    //     setStep(0);
    // }
    const onRpaStopConfirmed = async () => {
        try {
            setLastConfirmation((new Date()).valueOf());
            let lambdaResult = await lambda.invoke({ arnOrName: UCR_SAFETY_STOP_LAMBDA_ARN, payload: {} });
            if (lambdaResult.count_operations === lambdaResult.total_operations) {
                alertService.info("Stop RPA riuscito")
            } else {
                alertService.warn("Stop RPA riuscito parzialmente. ");

            }
        } catch (e) {
            console.error(e);
            alertService.error("Stop RPA fallito")
        }
        setLastConfirmation((new Date()).valueOf());
        setStep(0);
    }

    const gotoStep1 = () => setStep(1);
    const gotoStep0 = () => setStep(0);

    return <>
        <Stack spacing={2} justifyContent="space-between" sx={{ width: "100%", height: '90vh' }}>
            <Typography variant="h6" gutterBottom>
                Arresto di sicurezza
            </Typography>
            <Divider />
            <Box sx={{ flexGrow: .1 }} />
            {!canStop ? (
                <Typography variant="body1" gutterBottom>Non è possibile azionare il meccanismo di sicurezza troppo frequentemente.</Typography>
            ) : (
                <>
                    <Typography variant="body1" gutterBottom>
                        Premendo il pulsante sotto si può bloccare l'automazione. Attenzione: l'operazione non è reversibile. Per far ripartire l'automazione rivolgersi ad un amministratore.
                    </Typography>
                    {step === 0 && (
                        <Button color="warning" size="large" onClick={canStop && gotoStep1} variant="contained" disableElevation>
                            Ferma Automazione Unicredit
                        </Button>
                    )}
                    {step === 1 && (
                        <Stack spacing={2} direction="row" sx={{ width: "100%" }}>
                            <Button sx={{ width: "50%" }} color="primary" size="large" onClick={gotoStep0} variant="contained" disableElevation>
                                No, ci ho ripensato.
                            </Button>
                            <Button sx={{ width: "50%" }} color="error" size="large" onClick={onRpaStopConfirmed} variant="contained" disableElevation>
                                Si, sono sicuro di voler fermare l'automazione Unicredit
                            </Button>

                        </Stack>
                    )}
                </>
            )}

            <Box sx={{ flexGrow: 1 }} />
        </Stack>

    </>
}